<!-- 

CONFIGURACAO MELHOR ENVIO

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
    props: {
        obj: { type: Object },
    },

    components: {
    },

    data () {
        return {
            editing: false,
            melhorenvioObj: null,
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {

        handleDesativar () {
            this.obj.habilitaMelhorenvio = false
            console.log(this.obj.habilitaMelhorenvio)
            this.$emit('saveconfig')
        },

        handleAtivar () {
            this.editing = true
            this.melhorenvioObj = {...this.obj.melhorenvio}
            this.$nextTick(function () {
                this.$refs.clientid.focus()
            })
        },

        handleSalvar () {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.obj.habilitaMelhorenvio = true
                    this.editing = false
                    this.$emit('saveconfig')
                }
            })
        },

        handleEdit () {
            this.melhorenvioObj = {...this.obj.melhorenvio}
            this.editing = true            
            this.$nextTick(function () {
                this.$refs.clientid.focus()
            })
        },

        handleCancelar () {
            this.obj.melhorenvio = this.melhorenvioObj
            this.editing = false
            this.$emit('saveconfig')
        },

    },

    watch: {

    },

    mounted () {

    },

    created () {

    }

}

</script>

<template>
  <div class="mt-3">
    <span class="lbl-deal-title mb-3">Logística</span>

    <div class="row  mt-3 align-items-center" v-if="!editing && !obj.habilitaMelhorenvio">
        <div class="col-1">
            <img src="melhorenvio.png" height="40">
        </div>
        <div class="col-md-9">
            <span>Entregue seus produtos com o Melhor Envio. Entrega em todo o país com multiplas transportadoras.</span>
        </div>
        <div class="col-2">
            <v-button icon="" label="Configurar" @click="handleEdit"></v-button>
        </div>
    </div>

    <div class="row d-flex pl-2 mt-3" v-if="!editing && obj.habilitaMelhorenvio">
        <div class="col-2">
            <img src="melhorenvio.png" height="40">
        </div>
        <div class="col-5">
            <span>Sua loja está configurada com Melhor Envio!</span>
        </div>
        <div class="col-2">
            <span class="badge badge-green">Integração Ativada</span>
        </div>
        <div class="col-auto pr-0">
            <v-button icon="fa-pencil" label="" @click="handleEdit"></v-button>
            <v-button icon="" label="Desativar" @click="handleDesativar"></v-button>
        </div>
    </div>

    <div class="border p-3 mt-3 mb-3" v-if="editing">
        <div class="row">
            <div class="col-12 col-md-12 mb-3">
                <img src="melhorenvio.png" height="40">
            </div>
            <div class="col-md-3 col-12">
                <v-label label="Client ID"></v-label>
                <form-field ref="clientid" v-model="obj.melhorenvio.clientid" type="text" case="normal"
                :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="w-100"></div>
            <div class="col-md-3 col-12">
                <v-label label="Client Secret"></v-label>
                <form-field v-model="obj.melhorenvio.clientsecret" type="text" case="normal"
                :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="w-100"></div>
            <div class="col-md-2 col-6">
                <v-label label="Agência (JadLog)"></v-label>
                <form-field v-model="obj.melhorenvio.agencia" type="text" case="normal"
                :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.melhorenvio.maopropria" :value-checked="true" :value-unchecked="false" label="Serviço Mão Própria"></input-checkbox>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.melhorenvio.valordeclarado" :value-checked="true" :value-unchecked="false" label="Serviço Valor Declarado"></input-checkbox>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <input-checkbox v-model="obj.melhorenvio.avisorecebimento" :value-checked="true" :value-unchecked="false" label="Serviço Aviso de Recebimento"></input-checkbox>
            </div>
        </div>
        <div class="row">
            <alert type="info" title="Aviso" text="Produtos que não possuam dimensão e peso não serão exibidos na loja."></alert>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3" v-if="editing">
                <v-button label="Salvar" :success="true" @click="handleSalvar"></v-button>
                <v-button label="Cancelar" @click="handleCancelar"></v-button>
            </div>
        </div>
    </div>
  </div>

</template>

<style>


</style>



// WEBPACK FOOTER //
// src/forms-loja/config-melhorenvio-form-loja.vue